<div class="flex h-full">
  <aside
    class="flex w-60 shrink-0 flex-col border-r border-slate-200 bg-white text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100"
  >
    <div
      class="px-5 py-4 text-lg font-semibold tracking-wide text-slate-800 dark:text-slate-100"
    >
      iMatch
    </div>
    <nav class="flex flex-1 flex-col gap-1 px-2">
      @for (group of navGroups(); track $index) {
        @if (group.label) {
          <p
            class="px-3 pb-1 pt-4 text-[11px] font-semibold uppercase tracking-wide text-slate-400 dark:text-slate-500"
          >
            {{ group.label }}
          </p>
        }
        @for (item of group.items; track item.path) {
          <a
            [routerLink]="item.path"
            routerLinkActive="bg-slate-200 text-slate-900 dark:bg-slate-700 dark:text-white"
            class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
          >
            <span class="text-base">{{ item.icon }}</span>
            <span class="flex-1">{{ item.label }}</span>
            @if (item.badge) {
              <span
                class="inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold"
                [class]="
                  item.badgeAccent
                    ? 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900'
                    : 'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-200'
                "
                >{{ item.badge }}</span
              >
            }
          </a>
        }
      }
    </nav>

    <nav
      class="mt-auto flex flex-col gap-1 border-t border-slate-200 px-2 py-3 dark:border-slate-800"
    >
      @for (item of bottomNav(); track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="bg-slate-200 text-slate-900 dark:bg-slate-700 dark:text-white"
          class="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          <span class="text-base">{{ item.icon }}</span>
          {{ item.label }}
        </a>
      }
    </nav>
  </aside>

  <div class="flex flex-1 flex-col overflow-hidden">
    <header
      class="relative flex h-14 items-center justify-between gap-4 border-b border-slate-200 bg-white px-6 dark:border-slate-800 dark:bg-slate-900"
    >
      <!-- Recherche rapide -->
      @if (isAdmin()) {
        <form
          class="relative max-w-sm flex-1"
          (submit)="$event.preventDefault(); search(q.value)"
        >
          <span
            class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            >🔍</span
          >
          <input
            #q
            type="search"
            placeholder="Rechercher une offre, une compétence…"
            class="w-full rounded-lg border border-slate-200 bg-slate-50 py-2 pl-9 pr-3 text-sm text-slate-700 outline-none focus:border-slate-400 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
          />
        </form>
      } @else {
        <div class="flex-1"></div>
      }

      <div class="flex items-center gap-2">
        <!-- Thème -->
        <button
          type="button"
          (click)="theme.toggle()"
          [attr.aria-label]="
            theme.isDark() ? 'Activer le mode clair' : 'Activer le mode sombre'
          "
          class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-slate-200 text-base text-slate-600 hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          {{ theme.isDark() ? '☀️' : '🌙' }}
        </button>

        <!-- Cloche notifications -->
        @if (isAdmin()) {
          <div class="relative">
          <button
            type="button"
            (click)="toggleBell()"
            aria-label="Notifications"
            class="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-slate-200 text-base text-slate-600 hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          >
            🔔
            @if (notifications.unreadCount() > 0) {
              <span
                class="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white"
                >{{ notifications.unreadCount() }}</span
              >
            }
          </button>

          @if (bellOpen()) {
            <div
              class="absolute right-0 z-30 mt-2 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-800"
            >
              <div
                class="border-b border-slate-100 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-slate-400 dark:border-slate-700"
              >
                Notifications
              </div>
              @for (n of notifications.recent(); track n.id) {
                <div
                  class="flex items-start gap-2 border-b border-slate-50 px-4 py-2.5 last:border-0 dark:border-slate-700/60"
                >
                  <span
                    class="mt-0.5 h-2 w-2 shrink-0 rounded-full"
                    [class]="n.read ? 'bg-transparent' : 'bg-indigo-500'"
                  ></span>
                  <div class="min-w-0">
                    <p class="truncate text-sm font-medium text-slate-700 dark:text-slate-200">
                      {{ n.title }}
                    </p>
                    <p class="text-xs text-slate-400">{{ timeAgo(n.date) }}</p>
                  </div>
                </div>
              } @empty {
                <p class="px-4 py-6 text-center text-sm text-slate-400">
                  Aucune notification
                </p>
              }
              <a
                routerLink="/notifications"
                (click)="closeMenus()"
                class="block bg-slate-50 px-4 py-2.5 text-center text-sm font-medium text-indigo-500 hover:underline dark:bg-slate-800/60"
                >Tout voir</a
              >
            </div>
          }
          </div>
        }

        <!-- Menu utilisateur -->
        <div class="relative">
          <button
            type="button"
            (click)="toggleUserMenu()"
            class="flex cursor-pointer items-center gap-2 rounded-lg border border-slate-200 py-1 pl-1 pr-2 hover:bg-slate-100 dark:border-slate-700 dark:hover:bg-slate-800"
          >
            <span
              class="flex h-7 w-7 items-center justify-center rounded-full bg-indigo-500 text-xs font-bold text-white"
              >{{ userInitials() }}</span
            >
            <span class="text-sm text-slate-600 dark:text-slate-300">{{
              auth.userDisplayName()
            }}</span>
          </button>

          @if (userMenuOpen()) {
            <div
              class="absolute right-0 z-30 mt-2 w-48 overflow-hidden rounded-xl border border-slate-200 bg-white py-1 shadow-lg dark:border-slate-700 dark:bg-slate-800"
            >
              @if (isAdmin()) {
                <a
                  routerLink="/profile"
                  (click)="closeMenus()"
                  class="block px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700"
                  >👤 Profil</a
                >
              }
              <button
                type="button"
                (click)="theme.toggle()"
                class="block w-full cursor-pointer px-4 py-2 text-left text-sm text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700"
              >
                {{ theme.isDark() ? '☀️ Mode clair' : '🌙 Mode sombre' }}
              </button>
            </div>
          }
        </div>
      </div>

      @if (bellOpen() || userMenuOpen()) {
        <button
          type="button"
          (click)="closeMenus()"
          tabindex="-1"
          aria-hidden="true"
          class="fixed inset-0 z-20 cursor-default"
        ></button>
      }
    </header>
    <main class="flex-1 overflow-auto bg-slate-50 p-6 dark:bg-slate-950">
      <router-outlet />
    </main>
  </div>

  <app-toast-host />
</div>
